const AddEditLocationSkeleton = () => {
	return (
		<div className='dummy-skelton p-0'>
			<div className='box p-0'>
				<div className='skeleton p-0 '>
					<div className='skeleton-left flex1 p-0 '>
						<div className='d-flex'>
							<div className='line product-line w-25 me-2' />
							<div className='line product-line w-25  me-2' />
							<div className='line product-line w-25  me-2' />
							<div className='line product-line w-25 ' />
						</div>
						<div className='d-flex'>
							<div className='line product-line w-25 me-2' />
							<div className='line product-line w-25  me-2' />
							<div className='line product-line w-25  me-2' />
							<div className='line product-line w-25' />
						</div>
						<div className='d-flex'>
							<div className='line product-line w-100' />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddEditLocationSkeleton;
